import classNames from 'classnames';
import { FormField } from './FormField';
import type { FormFieldProps } from './FormField';
import type { ControllerFieldState } from 'react-hook-form';
import { Input } from 'antd';
import type { ComponentProps } from 'react';

export type TextAreaFieldProps = FormFieldProps &
    ComponentProps<typeof Input.TextArea> & {
        fieldState?: ControllerFieldState;
    };

export const TextAreaField = ({
    fieldState,
    label = '',
    disabled = false,
    showValidationIcon,
    error,
    correct,
    ...props
}: TextAreaFieldProps) => {
    const errorMessage = error || fieldState?.error?.message;
    const isValid = correct || (fieldState?.isDirty && !fieldState?.error?.message);

    const getInputClassName = () => {
        const inputClasses = classNames('input', {
            incorrect: errorMessage,
            correct: isValid,
        });
        return inputClasses;
    };

    return (
        <FormField
            {...props}
            fieldState={fieldState}
            label={label}
            labelFor={props?.id || props.name}
            error={error}
            correct={correct}
            showValidationIcon={showValidationIcon}>
            <Input.TextArea
                {...props}
                id={props?.id || props.name}
                className={getInputClassName()}
                aria-invalid={fieldState?.invalid ? 'true' : 'false'}
                disabled={disabled}
            />
        </FormField>
    );
};
